// src/selectors/allAtomsState.ts
import { selector } from "recoil";
import {
  childDobState,
  childFirstNameState,
  childHeightOptionState,
  childLastNameState,
  displayNameState,
} from "./child-details";
import {
  emailState,
  marketingPermissionState,
  parentFirstNameState,
  parentLastNameState,
  parentSignatureDateState,
  parentSignatureState,
  venueIdState,
} from "./parent-details";

export const storeState = selector({
  key: "storeState",
  get: ({ get }) => {
    const state = {
      parentFirstName: get(parentFirstNameState),
      parentLastName: get(parentLastNameState),
      email: get(emailState),
      childFirstName: get(childFirstNameState),
      childLastName: get(childLastNameState),
      displayName: get(displayNameState),
      dateOfBirth: get(childDobState),
      height: get(childHeightOptionState),
      marketingConsent: get(marketingPermissionState),
      signature: get(parentSignatureState),
      signatureDate: get(parentSignatureDateState),
      venueId: get(venueIdState),
    };
    return state;
  },
});
